// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"; // Import for Firebase Authentication
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// Your web app's Firebase configuration
const firebaseConfig = {
  //PRODUCTION BELOW
  apiKey: "AIzaSyAz_wA2MN_9e4G6qYhCLD9ccABzfxU0jjQ",
  authDomain: "auth.localizefood.com",
  databaseURL: "https://simplylocal-farmers-default-rtdb.firebaseio.com",
  projectId: "simplylocal-farmers",
  storageBucket: "simplylocal-farmers.appspot.com",
  messagingSenderId: "234683549649",
  appId: "1:234683549649:web:122f058f631f73ad4bc2f0",
  measurementId: "G-KHERYWMDRK",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app); // Initialize the Firebase auth service
const firestore = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Export the Firebase app and the services for use in your app
export { app, analytics, auth, firestore, storage, functions };
